import { FETCH_NETWORK_REPORT_DATA } from './constants';

export function fetchReportData(data) {
  return {
    type: FETCH_NETWORK_REPORT_DATA,
    payload: data,
  };
}
